// extracted by mini-css-extract-plugin
module.exports = {"input":"RadioCheckbox_input__3NGAw","indicator":"RadioCheckbox_indicator__TofRe"};